import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/itemsForResource.js'
import { useAuthStore } from '@/stores/auth.js'
import axios from 'axios'
export const useFundraiserPagePublicStore = (id = 'default') => {
  return defineStore({
    id: `fundraiserPagePublic_${id}`,
    state: () => ({
      ...state(),
      items: [],
      api: '/api/v1/fundraiser-pages-public',

    }),
    getters: {
      ...getters,
      getItemsByFundraiserId (state) {
        return (fundraiserId) => state.items.filter(item => item.fundraiser_id === fundraiserId)
      },
      getPublishedItemsByFundraiserId (state) {
        return (fundraiserId) => state.items.filter(item => item.fundraiser_id === fundraiserId && item.published || (useAuthStore().user && useAuthStore().user.id === item.owner_user_id))
      }
    },
    actions: {
      ...actions,
      async fetchItemByOldId(oldId) {
        const { data } = await axios.get(this.api, {
          params: {
            old_id: oldId
          }
        })
        if(data.data && data.data.length > 0 && data.data[0].old_id === oldId) {
          return data.data[0]
        }
        return null
      },
      async startDonation (payload) {
        const { data } = await axios.post(this.api + '/' + payload.fundraiser_page_id + '/donations', payload)
        return data
      },
      async confirmDonation (payload) {
        const { data } = await axios.post(this.api + '/' + payload.fundraiser_page_id + '/donations/' + payload.donation_id + '/confirm', payload)
        return data
      }
    }
  })()
}
